import { useState } from "react";
import { supa } from "./firebase";

function ModalPersonalTrainer({ visible, setVisible, aggiorna }) {
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [birth, setBirth] = useState(new Date());
    const [notes, setNotes] = useState('');
    const [retribuzione, setRetribuzione] = useState(0);

    async function addRow() {
        const { data, error } = await supa
            .from('personalTrainer')
            .insert({ "nome": name, "cognome": surname, "birth": birth, "note": notes, "costo": retribuzione })
        if (error) console.log(error)
        aggiorna()
        setVisible(false)
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="relative w-full max-w-2xl mx-4 animate-in fade-in zoom-in duration-200">
                <div className="relative bg-white rounded-2xl shadow-2xl border border-zinc-200">
                    {/* Header */}
                    <div className="flex items-center justify-between p-6 border-b border-zinc-200">
                        <div>
                            <h3 className="text-2xl font-bold text-zinc-900">Nuovo Personal Trainer</h3>
                            <p className="text-sm text-zinc-600 mt-1">Aggiungi un nuovo trainer al team</p>
                        </div>
                        <button 
                            onClick={() => setVisible(false)} 
                            className="p-2 text-zinc-400 hover:text-zinc-600 hover:bg-zinc-100 rounded-lg transition-all"
                        >
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Body */}
                    <form className="p-6">
                        <div className="grid gap-6 mb-6 md:grid-cols-2">
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Nome</label>
                                <input 
                                    type="text" 
                                    onChange={(e) => setName(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="Inserisci nome"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Cognome</label>
                                <input 
                                    type="text" 
                                    onChange={(e) => setSurname(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="Inserisci cognome"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Data di Nascita</label>
                                <input 
                                    type="date" 
                                    onChange={(e) => setBirth(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Costo per Lezione (€)</label>
                                <input 
                                    type="number" 
                                    onChange={(e) => setRetribuzione(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="0.00"
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Eventuali Note</label>
                                <textarea 
                                    onChange={(e) => setNotes(e.target.value)} 
                                    rows="4"
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all resize-none" 
                                    placeholder="Inserisci note..."
                                ></textarea>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-end gap-3 pt-4 border-t border-zinc-200">
                            <button 
                                type="button"
                                onClick={() => setVisible(false)}
                                className="px-5 py-2.5 text-sm font-semibold text-zinc-700 bg-zinc-100 hover:bg-zinc-200 rounded-xl transition-all"
                            >
                                Annulla
                            </button>
                            <button 
                                type="button"
                                onClick={() => addRow()}
                                className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-zinc-900 bg-yellow-400 hover:bg-yellow-500 rounded-xl shadow-sm hover:shadow transition-all"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd"></path>
                                </svg>
                                Aggiungi Personal Trainer
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ModalPersonalTrainer;
